import React, { useEffect, useState } from 'react';
import BASE_URL from '../config'; // Import BASE_URL

const ShowRgrSuppressions = () => {
  const [records, setRecords] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchRecords = () => {
      fetch(`${BASE_URL}api/proxy?action=latest_rgrsuppressions`) // Use BASE_URL
        .then((res) => res.json())
        .then((data) => {
          if (data.data) {
            setRecords(data.data);
            setError('');
          } else {
            setError('No data found.');
          }
        })
        .catch(() => {
          setError('Failed to fetch data.');
        });
    };

    fetchRecords(); // Initial fetch

    const interval = setInterval(fetchRecords, 5000); // Poll every 5 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  return (
    <div className="container mt-4">
      <h4 className="mb-3">Latest RGR Suppressions</h4>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead className="thead-dark">
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>Website</th>
              <th>Dated</th>
              <th>Sent to RGR</th>
            </tr>
          </thead>
          <tbody>
            {records.map((row) => (
              <tr key={row.id}>
                <td>{row.id}</td>
                <td>{row.email}</td>
                <td>{row.website}</td>
                <td >
  {row.dated
    ? (() => {
        const date = new Date(row.dated);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const time = date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        });
        return `${day}-${month}-${year} ${time}`;
      })()
    : ''}
</td>

                <td>{row.senttoRGR}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShowRgrSuppressions;
